import { map as _map } from 'lodash';
import { find as _find } from 'lodash';
import { filter as _filter } from 'lodash';

class MessagingController {
  constructor(authService, messagingService, loadingService, $state) {
    "ngInject";

    this.authService = authService;
    this.messagingService = messagingService;
    this.loadingService = loadingService;
    this.$state = $state;

    this.filterParams = {};
  }

  reset() {
    const ctrl = this;

    this.filterParams.userId = this.authService.authData.userId;
    this.filterParams.messagesType = this.activeTab;

    this.pagination = {
      totalItems: 0,
      currentPage: 1,
      pageSize: 10
    };

    this.filterParams.pageCriteria = {
      pageStart: 0,
      itemsToFetch: this.pagination.pageSize,
      sortExpression: 'received',
      ascending: false
    };

    this.notification = {
      type: 'info',
      msg: ''
    };

    this.listMessages();
  }

  updatePageIndex() {
    if (this.pagination.currentPage === 1) {
      this.filterParams.pageCriteria.pageStart = 0;
    }
    else {
      this.filterParams.pageCriteria.pageStart = ((this.pagination.currentPage-1) * this.pagination.pageSize);
    }
  }

  updateSort(fieldName) {
    if (this.filterParams.pageCriteria.sortExpression === fieldName) {
      this.filterParams.pageCriteria.ascending = !this.filterParams.pageCriteria.ascending;
    }
    else {
      this.filterParams.pageCriteria.sortExpression = fieldName;
      this.filterParams.pageCriteria.ascending = true;
    }

    this.listMessages();
  }

  listMessages() {
    const ctrl = this;

    ctrl.updatePageIndex();

    ctrl.loadingService.showLoading('messagingListing', 'Loading Messages ...');

    ctrl.messagingService.listMessages(ctrl.filterParams)
      .then(response => {
        ctrl.messages = response.data.items;
        ctrl.pagination.totalItems = response.data.totalRecords;

        if (ctrl.pagination.totalItems === 0) {
          ctrl.notification = {
            type: 'info',
            msg: `No data to display`
          }
        }
        else {
          const pageEnd = (ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize) < response.data.totalRecords ? (ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize) :  response.data.totalRecords;

          ctrl.notification = {
            type: 'info',
            msg: `Currently display ${(ctrl.filterParams.pageCriteria.pageStart+1)} to ${pageEnd} out of ${ctrl.pagination.totalItems} messages`
          }
        }
      })
      .catch(err => {
        ctrl.notification = {
          type: 'error',
          msg: "An error occurred while fetching messages." + (err.data ? err.data.messageDetail : '')
        }
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('messagingListing');
      });
  }

  viewMessage(message) {
    if (!message.read) {
      this.authService.authData.msgCount--;
    }

    this.$state.go('messageView', {messageId: message.messageId});
  }

  showInbox() {
    this.activeTab = 'inbox';
    this.reset();
  }

  showOutbox() {
    this.activeTab = 'outbox';
    this.reset();
  }
}

export default MessagingController;



// WEBPACK FOOTER //
// ./client/app/components/messaging/messaging.controller.js